<h5 mat-dialog-title>
    <div class="col-md-12 p-0 row delete-header">
        <div class="col-md-10 p-0 post-lca-title">Post LCA</div>
        <div class="col-md-2 p-0 justify-content-end d-flex">
        <i (click)="onDismiss();" class="close-icon pi pi-times"></i>
        </div>
    </div>
</h5>
<div class="post-lca-form" mat-dialog-content>
  <form [formGroup]="lcaPostingForm" (ngSubmit)="postLCAData()">
        <p class="post-lca-form-main-label mb-2">Posting Details</p>
        <div class="row pt-2 pb-2 mb-0 dashed-border-bottom">
            <div class="p-field col-md-6 p-0">
                <label class="col-md-12 p-0" for="lcaPostingDate">LCA Posting Date:</label>
                <div class="col-md-12 p-0">
                    <p-calendar id="lcaPostingDate" tabindex="-1" [minDate]="minimumDate" [showIcon]="true" dateFormat="dd M yy" formControlName="lcaPostingDate"></p-calendar>
                </div>
              </div>
            
              <div class="p-field col-md-6 p-0">
                <label class="col-md-12 p-0" for="lcaExpiryDate">No. of days LCA should be Posted</label>
                <div class="col-md-12 p-0">
                    <p-dropdown id="lcaExpiryDate" [options]="daysOptions" formControlName="lcaExpiryDate"></p-dropdown>
                </div>
              </div>
        </div>
      
        <div class="p-field row pt-2 pb-2 mb-0 dashed-border-bottom">
          <label class="col-md-12 p-0 pb-2 post-lca-form-main-label">Take Down LCA Posting</label>
          <div class="col-md-12 p-0">
            <p-radioButton
            class="pr-3"
            *ngFor="let option of takeDownOptions"
            [label]="option.label"
            [value]="option.value"
            formControlName="takeDownOption"
          ></p-radioButton>
          </div>
          <span [hidden]="lcaPostingForm.controls['takeDownOption'].value == 'Manual Take Down'" class="auto-selection-info pt-2"><b>Alert message </b>:- <i>This posting will be disabled in {{lcaPostingForm.controls['lcaExpiryDate'].value}} days.</i></span>

          <span [hidden]="lcaPostingForm.controls['takeDownOption'].value == 'Auto Take Down'" class="manual-selection-info pt-2">You have selected to take down the posting manually. <br> You will receive a notification reminder to take down the posting on the {{lcaPostingForm.controls['lcaExpiryDate'].value}}th day.</span>
        </div>

        <div class="p-field row pt-2 pb-2 mb-0 dashed-border-bottom">
          <label class="col-md-12 p-0 pb-2 post-lca-form-main-label">URL for the posted LCA</label>
          <div class="row col-md-12 p-0">
            <div class="col-md-6 p-0">
                <p>Use this URL to view all posted LCAs.</p>
                <a href="{{jobPostingUrl}}" target="_blank">{{jobPostingUrl}}</a>
            </div>
            <div class="col-md-6 p-0">
              <button type="button" label="COPY URL" (click)="copyUrl()" class="btn btn-primary mt-0 float-right btn-add">COPY URL</button>
            </div>
          </div>
        </div>

        <div class="p-field row pt-2 pb-2 mb-0 ">
          <label class="col-md-12 p-0 pb-2 post-lca-form-main-label">Button Snippet</label>
          <div class="row col-md-12 p-0">
            <p>Copy the button snippet to your company website</p>
            <div class="row col-md-12 p-4 box-border">
              <div class="col-md-8 pl-0">
                <p class="post-lca-form-main-label">Code</p>
                <pre>{{ htmlTemplate }}</pre>
              </div>
              <div class="col-md-4 preview-section">
                <p class="post-lca-form-main-label pb-3">Preview</p>
                <button style="min-width: 150px; background-color: #19a0da; border: none; border-radius: 8px; padding: 8px;">
                  <a style="color: #FFFFFF; font-size: 14px; text-decoration: none;" href="{{jobPostingUrl}}" target="_blank">VIEW JOB POSTING</a>
                </button>
              </div>
            </div>
          </div>
        </div>
<!-- Documents -->
</form>
</div>

<!-- This Files upload will go as separate release as an enhancement -->
<!-- <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload> -->

<div mat-dialog-actions class="float-right">
  <button mat-button (click)="onDismiss()">Cancel</button>
  <button class="post-lca-button" pButton [disabled]="lcaPostingForm.invalid" (click)="postLCAData()">POST</button>
</div>

<div class="clearfix"></div>